import { useMedia } from 'react-use';

const useDevice = () => {
  const isMobileSm = useMedia('(max-width : 640px)');
  const isMobile = useMedia('(max-width: 768px)');
  const isTablet = useMedia('(min-width: 769px) and (max-width: 1024px)');
  const isDesktop = useMedia('(min-width: 1025px)');
  const isMobile767 = useMedia('(max-width: 767px)');
  const isTablet768 = useMedia('(min-width: 768px) and (max-width: 1024px)');

  return {
    isMobileSm,
    isMobile,
    isTablet,
    isDesktop,
    isMobile767,
    isTablet768,
  };
};

export default useDevice;
